import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { ErrorMessage, Field, Form, Formik } from "formik";
import Modal from "react-modal";
import * as Yup from "yup";
import { FaTimes } from "react-icons/fa";

//import ModalAgregarContendor from "./ModalAgregarContenedor";

import { CampoSelect } from "../../../../helpers/CampoSelect";
import { CampoSelectAsync } from "../../../../helpers/CampoSelectAsync";
import { editSolicitud, getOneSolicitud, getAllNavierasSolicitud } from "../../../../helpers/Api";


const ModalEditSolicitud = ({ idSolicitudEdit, modalIsOpen, closeModal }) => {


    const [navierasOptions, setNavierasOptions] = useState([]);
 
    const customStyles = {
        content: {
          top: "50%",
          left: "50%",
          width: "50%",
          height: "62%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          background: "linear-gradient(141.48deg, #DBFBFF -2.31%, #DBE9FF 101.54%)",
          borderRadius: "5px",
          border: "none",
          boxShadow: "0px 11px 30px 12px rgba(0, 0, 0, 0.04)",
        },
        overlay: { zIndex: 1000 },
      };    

  //ROUTER
  const token = localStorage.getItem('token');
  const idAgencia = localStorage.getItem('agencia');
//STATES
  const [ data, setData ] = useState([]);

  useEffect(() => {
    modalIsOpen && handlerGetOneSolicitud();
  }, [modalIsOpen])


  const handlerGetOneSolicitud = async () => {
    try {
        const response = await getOneSolicitud(idSolicitudEdit, token);
        if(response) {
        setData(response)
        }
    } catch (error) {
        throw error
    }
  }

  const getAllNavieras = async (search) => {
    try {
      const response = await getAllNavierasSolicitud(search, token);
      if (response) {
        setNavierasOptions(response.results)
        return response
      }
    } catch (error) {
      throw error
    }
  }

    //Convenio de Colaboracion
    const aplicaConvenio = [
      { value: true, label: "Aplica convenio" },
      { value: false, label: "No aplica convenio" },
    ];

  let initialValues = {
    referencia: data?.referencia || "",
    numero_bl: data?.numero_bl || "",
    rfc: data?.rfc || "",
    cliente: data?.cliente || "",
    naviera: data?.naviera && {value: data.naviera, label: data.naviera_nombre},
    fecha_eta: data?.fecha_eta || "",
    fecha_revalidacion: data?.fecha_revalidacion || "",
    convenio_colaboracion: data?.convenio_colaboracion ? aplicaConvenio[0] : aplicaConvenio[1],
  };


  const handlerEditSolicitud = async (values) => {
    try {
      const response = await editSolicitud(
        idSolicitudEdit, {
        referencia: values.referencia,
        numero_bl: values.numero_bl,
        rfc: values.rfc,
        cliente: values.cliente,
        naviera: values.naviera.original_value ? values.naviera.original_value.clave : data?.naviera ,
        fecha_revalidacion: values.fecha_revalidacion,
        fecha_eta: values.fecha_eta,
        convenio_colaboracion: values.convenio_colaboracion.value,
        agencia_aduanal_id: idAgencia,
      }, token);
      if (response.status === 200) {
        Swal.fire("Exito", "Los cambios han sido guardados exitosamente", "success");
        closeModal();
      }
    } catch (error) {
      let data = error.request.response
      Swal.fire(
        "Oops",
        `Ha surgido un problema al guardar la solicitud ${data}`,
        "error"
      );
    }
  };


  return (
    <Modal
    isOpen={modalIsOpen}
    onRequestClose={closeModal}
    style={customStyles}
    contentLabel="Example Modal"
    ariaHideApp={false}
  >
   <div className="row m-1">
        <div className="col-12  d-flex flex-row-reverse">
          <button className="btn" onClick={closeModal}>
            <FaTimes onClick={closeModal} style={{ color: "#F47777" }} />
          </button>
        </div>
      </div>
    <div className="row mb-5">
      <div className="col-12" style={{padding : '2rem'}}>
          <Formik
            enableReinitialize="true"
            initialValues={initialValues}
            validationSchema={Yup.object().shape({
              referencia: Yup.string().required("Campo requerido"),
              numero_bl: Yup.string().required("Campo requerido"),
              rfc: Yup.string().required("Campo requerido"),
              cliente: Yup.string().required("Campo requerido"),
              fecha_eta: Yup.string().required("Campo requerido"),
              fecha_revalidacion: Yup.string().required("Campo requerido"),
            })}
            onSubmit={(values, { resetForm }) => {
              handlerEditSolicitud(values);
              resetForm();
            }}
          >
            {(props) => (
              <Form>
                <>
                  <div className="row">
                    <h6>Formato de solicitud</h6>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Referencia
                      </label>
                      <Field
                        type="text"
                        name="referencia"
                        className="form-control mb-3"
                      />
                      <ErrorMessage name="referencia" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Número de BL
                      </label>
                      <Field
                        type="text"
                        name="numero_bl"
                        className="form-control mb-3"
                      />
                      <ErrorMessage name="numero_bl" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Cliente
                      </label>
                      <Field
                        type="text"
                        name="cliente"
                        className="form-control mb-3"
                      />
                      <ErrorMessage name="cliente" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        RFC del Cliente
                      </label>
                      <Field 
                      type="text" 
                      name="rfc"
                      onKeyUp={e  => e.target.value.toUpperCase()}
                      value={props.values.rfc.toUpperCase()}
                      className="form-control mb-3" />
                      <ErrorMessage name="rfc" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Fecha de Atraque
                      </label>
                      <Field
                        type="date"
                        name="fecha_eta"
                        className="form-control"
                      />
                       <ErrorMessage name="fecha_eta" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Fecha de revalidación
                      </label>
                      <Field
                        type="date"
                        name="fecha_revalidacion"
                        className="form-control mb-3"
                      />
                      {/* {props.values.fecha_revalidacion && 
                      props.values.fecha_eta > props.values.fecha_revalidacion ? 
                      <p className="requiredField" style={{marginTop: '0.5em'}}>
                      La fecha debe de ser igual o mayor que la fecha de atraque</p>  
                      : null } */}
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Naviera
                      </label>
                      <CampoSelectAsync
                        blank={false}
                        name="naviera"
                        fieldShow="nombre" 
                        selectedValue={props.values["naviera"]} 
                        remoteCall={getAllNavieras}
                        onChange={props.setFieldValue} 
                        placeholder="Seleccione naviera"                        
                        />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Convenio de Colaboración
                      </label>
                      <CampoSelect
                        type="text"
                        name={"convenio_colaboracion"}
                        valores={aplicaConvenio}
                        onChange={props.setFieldValue}
                        selectedValue={props.values.convenio_colaboracion}
                        className="form-control mb-3"
                        placeholder="Seleccione el tipo de convenio"
                      />
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col-12">
                      <div className="d-flex flex-row-reverse cta_solicitud">
                      {/* {props.values.fecha_eta > props.values.fecha_revalidacion ?  */}
                        <button
                          className="btn"
                          type="submit"
                          style={{ backgroundColor: "#1F107D", width: "10rem" }}
                        >
                          Guardar cambios
                        </button> 
                        {/* : */}
                        {/* <button
                          className="btn"
                          type="submit"
                          style={{ backgroundColor: "#1F107D", width: "10rem" }}
                        >
                          Guardar cambios
                        </button>  */}
                      {/* } */}
                        
                      </div>
                    </div>
                  </div>
                </>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  );
};

export default ModalEditSolicitud;
